import { render, staticRenderFns } from "./addStudentOrder.vue?vue&type=template&id=0dcc8cf0&"
import script from "./addStudentOrder.vue?vue&type=script&lang=js&"
export * from "./addStudentOrder.vue?vue&type=script&lang=js&"
import style0 from "./addStudentOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports